import { Action } from 'redux';
import { EstadisticasSector, Sector } from '../../../models/Entities/Turnero';
import { TurneroSectoresState, TurneroSectoresUnloadState } from '../../states/Turnero-Sectores.State';

export default function TurneroSectoresReducer(
    state: TurneroSectoresState | undefined,
    action: Action
): TurneroSectoresState {
    const currentState = state ?? TurneroSectoresUnloadState;
    const a: any = action;

    switch (a.type) {
        case 'TURNERO-SECTORES_GET_ALL_REQUEST':
            return {
                ...currentState,
                isLoadingAll: true,
                successLoadingAll: false,
                failOnLoadingAll: false,
                error: undefined
            } as TurneroSectoresState;
        case 'TURNERO-SECTORES_GET_ALL_SUCCESS':
            return {
                ...currentState,
                isLoadingAll: false,
                successLoadingAll: true,
                failOnLoadingAll: false,
                error: undefined,
                list: a.payload || []
            } as TurneroSectoresState;
        case 'TURNERO-SECTORES_GET_ALL_FAILURE':
            return {
                ...currentState,
                isLoadingAll: false,
                successLoadingAll: false,
                failOnLoadingAll: true,
                error: a.error
            } as TurneroSectoresState;

        case 'TURNERO-SECTORES_CREATE_REQUEST':
            return {
                ...currentState,
                isAddingNewOne: true,
                successAddingNewOne: false,
                failOnAddingNewOne: false,
                error: undefined
            } as TurneroSectoresState;
        case 'TURNERO-SECTORES_CREATE_SUCCESS':
            return {
                ...currentState,
                isAddingNewOne: false,
                successAddingNewOne: true,
                failOnAddingNewOne: false,
                error: undefined,
                list: [...(currentState.list || []), a.payload]
            } as TurneroSectoresState;
        case 'TURNERO-SECTORES_CREATE_FAILURE':
            return {
                ...currentState,
                isAddingNewOne: false,
                successAddingNewOne: false,
                failOnAddingNewOne: true,
                error: a.error
            } as TurneroSectoresState;

        case 'TURNERO-SECTORES_GET_BY_ID_REQUEST':
            return {
                ...currentState,
                isLoadingOne: true,
                successLoadingOne: false,
                failOnLoadingOne: false,
                error: undefined
            } as TurneroSectoresState;
        case 'TURNERO-SECTORES_GET_BY_ID_SUCCESS': {
            const updatedList = [...(currentState.list || []).filter((s: Sector) => s.id !== a.payload.id), a.payload];
            return {
                ...currentState,
                isLoadingOne: false,
                successLoadingOne: true,
                failOnLoadingOne: false,
                error: undefined,
                list: updatedList
            } as TurneroSectoresState;
        }
        case 'TURNERO-SECTORES_GET_BY_ID_FAILURE':
            return {
                ...currentState,
                isLoadingOne: false,
                successLoadingOne: false,
                failOnLoadingOne: true,
                error: a.error
            } as TurneroSectoresState;

        case 'TURNERO-SECTORES_UPDATE_REQUEST':
            return {
                ...currentState,
                isUpdatingOne: true,
                successUpdatingOne: false,
                failOnUpdatingOne: false,
                error: undefined
            } as TurneroSectoresState;
        case 'TURNERO-SECTORES_UPDATE_SUCCESS': {
            const updatedList = (currentState.list || []).map((s: Sector) =>
                s.id === a.id ? { ...s, ...a.payload } : s
            );
            return {
                ...currentState,
                isUpdatingOne: false,
                successUpdatingOne: true,
                failOnUpdatingOne: false,
                error: undefined,
                list: updatedList
            } as TurneroSectoresState;
        }
        case 'TURNERO-SECTORES_UPDATE_FAILURE':
            return {
                ...currentState,
                isUpdatingOne: false,
                successUpdatingOne: false,
                failOnUpdatingOne: true,
                error: a.error
            } as TurneroSectoresState;

        case 'TURNERO-SECTORES_DELETE_REQUEST':
            return {
                ...currentState,
                isDeletingOne: true,
                successDeletingOne: false,
                failOnDeletingOne: false,
                error: undefined
            } as TurneroSectoresState;
        case 'TURNERO-SECTORES_DELETE_SUCCESS':
            return {
                ...currentState,
                isDeletingOne: false,
                successDeletingOne: true,
                failOnDeletingOne: false,
                error: undefined,
                list: (currentState.list || []).filter((s: Sector) => s.id !== a.payload)
            } as TurneroSectoresState;
        case 'TURNERO-SECTORES_DELETE_FAILURE':
            return {
                ...currentState,
                isDeletingOne: false,
                successDeletingOne: false,
                failOnDeletingOne: true,
                error: a.error
            } as TurneroSectoresState;

        case 'TURNERO-SECTORES_GET_ESTADISTICAS_REQUEST':
            return {
                ...currentState,
                isLoadingEstadisticas: true,
                successLoadingEstadisticas: false,
                failOnLoadingEstadisticas: false,
                error: undefined
            } as TurneroSectoresState;
        case 'TURNERO-SECTORES_GET_ESTADISTICAS_SUCCESS': {
            const nextEstadisticas = { ...(currentState.estadisticas || {}) };
            nextEstadisticas[a.sectorId] = a.payload as EstadisticasSector;
            return {
                ...currentState,
                isLoadingEstadisticas: false,
                successLoadingEstadisticas: true,
                failOnLoadingEstadisticas: false,
                error: undefined,
                estadisticas: nextEstadisticas
            } as TurneroSectoresState;
        }
        case 'TURNERO-SECTORES_GET_ESTADISTICAS_FAILURE':
            return {
                ...currentState,
                isLoadingEstadisticas: false,
                successLoadingEstadisticas: false,
                failOnLoadingEstadisticas: true,
                error: a.error
            } as TurneroSectoresState;

        default:
            return currentState as TurneroSectoresState;
    }
}
